import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}
 
let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Date",
    field: "date_time",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date", 
    },
  },
  {
    label: "Expense No.",
    field: "expense_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Expense No.", 
    },
  },
  {
    label: "Party",
    field: "party_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party",
    },
  },
  {
    label: "Category",
    field: "category",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Category",
    },
  },
  {
    label: "Amount",
    field: "amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Amount",
    },
  },
  {
    label: "Balance",
    field: "balance",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Balance",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,

      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,

      startDate: moment(_startDateYaer).format("YYYY-MM-DD"),
      endDate: moment(_endDateYaer).format("YYYY-MM-DD"),
      dateLabel: "",
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getSaleListData(_type) {
    let _transArray = [];

    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      type: _type,
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
    });

    PostData(global.expenseTransactionsReport, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (!responseJson.success || !responseJson.response) {
          this.setState({
            transactionArrayFilter: [],
            itemArray: [],
            isLoaded: true,
            countList: 0
          });
        } else {
          _transArray = responseJson.response.map((itm) => ({
            srNo: itm.srNo,
            date_time: itm.date,
            expense_no: itm.expense_no,
            party_name: itm.party_name,
            category: itm.expense_category,
            amount: itm.amount,
            balance: itm.balance
          }));

          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            countList: responseJson.response.length
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    let dataList = { columns: columns, rows: [] };

    if (this.state.isLoaded) {
      const _transDetails = this.state.transactionArrayFilter;

      if (_transDetails.length > 0) {
        let rows = _transDetails.map((value) => ({
          sr_no: value.srNo,
          date_time: value.date_time,
          expense_no: value.expense_no,
          party_name: value.party_name,
          category: value.category,
          item_name: value.item_name,
          amount: numberFormat(value.amount),
          balance: numberFormat(value.balance)
        }));
        dataList.rows = rows;
      }
    }
    return dataList;
  }


  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  exportData = (event) =>{
    let _itemDetails = this.state.transactionArrayFilter;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'Sr No.': data.srNo,
          'Date': data.date_time,
          'Expense No.': data.expense_no,
          'Party Name': data.party_name,
          'Category': data.category,
          'Amount': numberFormat(data.amount),
          'Balance': numberFormat(data.balance)
        }
         return newData;
      });

      let totalAmountRow = {
        'Sr No.': '',
        'Date': '',
        'Expense No.': '',
        'Party Name': '',
        'Category': '',
        'Amount': '',
        'Balance': ''
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Expense Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_expense_report_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Stock Summary</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Sale
                                        </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
